/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const workInfoWorkTypeQuery = params => {
  return axios.post(`${base}/work_info_work_type/query`, params)
}

export const workInfoWorkTypeCreate = params => {
  return axios.post(`${base}/work_info_work_type/create`, params)
}

export const workInfoWorkTypeEdit = params => {
  return axios.post(`${base}/work_info_work_type/${params.id}/edit`, params)
}

export const workInfoWorkTypeGet = id => {
  return axios.get(`${base}/work_info_work_type/${id}`)
}

export const workInfoWorkTypeDelete = id => {
  return axios.post(`${base}/work_info_work_type/${id}/delete`)
}

export const workInfoWorkTypeChangeStatus = params => {
  return axios.post(`${base}/work_info_work_type/${params.id}/status`, {status: params.status})
}




// WEBPACK FOOTER //
// ./src/views/work-info-work-type/work-info-work-type.api.js